import { render, staticRenderFns } from "./WidowedDistributionToOtherDetails.vue?vue&type=template&id=52185438"
import script from "./WidowedDistributionToOtherDetails.vue?vue&type=script&lang=js"
export * from "./WidowedDistributionToOtherDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports